module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av323-cbb739659df7dc70fcceaa917c8a1e49.jpg";